import React from 'react';
import { Helmet } from 'react-helmet';
import { Box, Typography, Button } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { getCanonicalUrl } from '../utils/canonicalUrl';

export default function FreeAIThankYou() {
  const location = useLocation();
  const canonicalUrl = getCanonicalUrl(location.pathname);
  return (
    <Box textAlign="center" sx={{ color: 'common.white' }}>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <title>Thank You - Free AI Assessment</title>
        <meta name="description" content="Confirmation that your free AI assessment request was received." />
        <meta property="og:title" content="Thank You - Free AI Assessment" />
        <meta property="og:description" content="We will review your submission and follow up shortly." />
        <meta property="og:image" content="/assets/visuals/re-profile-blue-ai-hud.webp" />
      </Helmet>
      <Typography variant="h4" component="h1" gutterBottom>
        Thank You
      </Typography>
      <Typography gutterBottom>
        Your assessment has been submitted. We'll be in touch soon.
      </Typography>
      <Button variant="contained" color="secondary" component={Link} to="/">
        Back to Home
      </Button>
    </Box>
  );
}
